function init() {
  const drawerHandle = document.getElementById("filterCustom");
  const drawer = document.getElementById("custom-drawer");
  const overlay = document.getElementById("custom-drawer-overlay");
  const close = document.getElementById("closeCustomFilter");
  const filters = document.querySelectorAll(".filterContainer");

  drawerHandle.addEventListener("click", () => {
    if (drawer.getAttribute("data-open") === "false") {
      drawer.setAttribute("data-open", "true");
      overlay.setAttribute("data-open", "true");
    } else {
      drawer.setAttribute("data-open", "false");
      overlay.setAttribute("data-open", "false");
    }
  });

  close.addEventListener("click", () => {
    drawer.setAttribute("data-open", "false");
    overlay.setAttribute("data-open", "false");
  });

  overlay.addEventListener("click", () => {
    drawer.setAttribute("data-open", "false");
    overlay.setAttribute("data-open", "false");
  });

  filters.forEach((filter) => {
    filter.querySelector("svg").style.transform = "rotate(180deg)";
    filter.addEventListener("click", () => {
      if (filter.nextElementSibling.classList.contains("chevronesClosed")) {
        filter.nextElementSibling.classList.remove("chevronesClosed");
        filter.nextElementSibling.classList.add("chevronesOpened");
        filter.querySelector("svg").style.transform = "rotate(180deg)";

      } else {
        filter.querySelector("svg").style.transform = "rotate(0deg)";
        filter.nextElementSibling.classList.remove("chevronesOpened");
        filter.nextElementSibling.classList.add("chevronesClosed");

      }
    });
  });

  const swatches = document.querySelectorAll('.contenedorSwatch');

  // const priceRange = document.getElementById("priceRange");

  const sizes = document.querySelectorAll('.sizeCustom');

  const booleans = document.querySelectorAll('.boolCustom');

  const clearBtn = document.querySelector('.filterClearBtn');
  const submitBtn = document.querySelector('.filterSubmitBtn');
  
  
  const updateButtonStates = () => {
    let counter = 0;
    const filtersApplied = document.querySelector('.cus-collection-view-filters-applied');

    if (!clearBtn || !submitBtn) {
      console.warn('Filter buttons not found in the DOM');
      return;
    }

    const hasCheckedInputs = [...swatches, ...sizes, ...booleans].some(element => {
      const inputId = element.dataset.color || element.dataset.size || element.dataset.cusbool;
      return document.getElementById(inputId).checked;
    });

    const listOfActiveFilters = [...swatches, ...sizes, ...booleans].filter(element => element.classList.contains('cus-filter-active'));
    if(listOfActiveFilters.length > 0){
      counter = listOfActiveFilters.length;
    }

    if(counter > 0){
      const priceRange = document.getElementById("priceRange");
      const maxPrice = priceRange.getAttribute("data-max");

      // Min price is set to 300
      const minPrice = 300;

      const priceRangeMax = Number(document.getElementById("priceRangeMax").value.replace(/[$,]/g, ''));
      const priceRangeMin = Number(document.getElementById("priceRangeMin").value.replace(/[$,]/g, ''));

      if(priceRangeMax != "" && priceRangeMax < maxPrice || priceRangeMin !== "" && priceRangeMin > minPrice){
        counter++;
      }
    }

    if (counter > 0 && filtersApplied) {
      filtersApplied.setAttribute("data-active", true);
      filtersApplied.innerHTML = counter;

    }
    
    // clearBtn.disabled = !hasCheckedInputs;
    // submitBtn.disabled = !hasCheckedInputs;
    
    // clearBtn.classList.toggle('disabled', !hasCheckedInputs);
    // submitBtn.classList.toggle('disabled', !hasCheckedInputs);


  };
  

  for (let index = 0; index < swatches.length; index++) {
    const element = swatches[index];
    element.addEventListener('click', () => {
      const checkboxColor = document.getElementById(element.dataset.color);
      checkboxColor.checked = !checkboxColor.checked;

      console.log({
        "checked": checkboxColor.checked,
        "id": checkboxColor.id
      })

      if(checkboxColor.checked){
        swatches[index].classList.add('cus-filter-active');
      } else {
        swatches[index].classList.remove('cus-filter-active')
      }
      updateButtonStates();
    });
  }

  for (let index = 0; index < sizes.length; index++) {
    const element = sizes[index];
    element.addEventListener('click', () => {
      const checkboxSize = document.getElementById(element.dataset.size);
      checkboxSize.checked = !checkboxSize.checked;
      console.log({
        "checked": checkboxSize.checked,
        "id": checkboxSize.id
      })

      if(checkboxSize.checked){
        sizes[index].classList.add('cus-filter-active');
      } else {
        sizes[index].classList.remove('cus-filter-active')
      }
      updateButtonStates();
    });
  }

  for (let index = 0; index < booleans.length; index++) {
    const element = booleans[index];
    element.addEventListener('click', () => {
      const checkboxBoolean = document.getElementById(element.dataset.cusbool);
      const checkboxBooleanSVG = element.querySelector(".boolCustomCheckSVG");
      checkboxBoolean.checked = !checkboxBoolean.checked;
      
      if(checkboxBoolean.checked){
        booleans[index].classList.add('cus-filter-active');
        checkboxBooleanSVG.classList.remove('booleanChecked');
      } else {
        booleans[index].classList.remove('cus-filter-active');
        checkboxBooleanSVG.classList.add('booleanChecked');
      }
      updateButtonStates();
    });
  }

  updateButtonStates();

  // clearBtn.addEventListener("click", (e) => {
  //   e.preventDefault();
  //   console.log("clicked")
  //   let checkedInputs = [];
  //   [...swatches, ...sizes, ...booleans].some(element => {
  //     const inputId = element.dataset.color || element.dataset.size || element.dataset.cusbool;
  //     const input = document.getElementById(inputId);
  //     if(input.checked){
  //       checkedInputs.push(inputId);
  //     }
  //   })
  //   checkedInputs.forEach(inputId => {
  //     const input = document.getElementById(inputId);
  //     input.checked = false;
  //     const container = document.querySelector(`div:has(+ input[id="${inputId}"])`);
  //     console.log(inputId)
  //     console.log(container)
  //     container.classList.remove('cus-filter-active');
  //   })
    
  //   // priceRange.value = priceRange.getAttribute("max");
  //   // document.getElementById("priceValue").innerHTML = "$ " + priceRange.value;

  //   submitBtn.removeAttribute("disabled");
  //   submitBtn.classList.remove("disabled");

  //   updateButtonStates();
  // })

  // priceRange.addEventListener("change", (e) => {
  //   priceRange.value = e.target.value;
  //   document.getElementById("priceValue").innerHTML = "$ " + e.target.value;

  //   if(priceRange.value !== priceRange.getAttribute("max")){
  //     clearBtn.removeAttribute("disabled");
  //     clearBtn.classList.remove("disabled");
  //     submitBtn.removeAttribute("disabled");
  //     submitBtn.classList.remove("disabled");
  //   }
  // })
}

window.addEventListener("DOMContentLoaded", function(){
  setTimeout(() => {
    init();
    initRangeSlider();
  }, 1000);
}, false);

function initRangeSlider(){
  let slider = document.getElementById('priceRange');

  let max = Number(slider.getAttribute("data-max"));
  let min = 300;

  let minStart = Number(slider.getAttribute("data-min-start"));
  let maxStart = Number(slider.getAttribute("data-max-start"));

  let priceRangeMin = document.getElementById("priceRangeMin");
  let priceRangeMax = document.getElementById("priceRangeMax");

  const clearBtn = document.querySelector('.filterClearBtn');
  const submitBtn = document.querySelector('.filterSubmitBtn');

  if(priceRangeMax.value != "" && priceRangeMax.value !== maxStart || priceRangeMin.value != "" && priceRangeMin.value !== minStart){
    clearBtn.removeAttribute("disabled");
    clearBtn.classList.remove("disabled");
    submitBtn.removeAttribute("disabled");
    submitBtn.classList.remove("disabled");
  }

  noUiSlider.create(slider, {
    start: [minStart, maxStart],
    step: 50,
    margin: 200,
    tooltips: [true, true],
    connect: true,
    range: {
      'min': min,
      'max': max
    },
    format: {
      to: function(value) {
        return Math.round(value);
      },
      from: function(value) {
        return Number(value);
      }
    }
  });

  slider.noUiSlider.on('set', (values, handle) => {
    priceRangeMin.value = values[0];
    priceRangeMax.value = values[1];

    clearBtn.removeAttribute("disabled");
    clearBtn.classList.remove("disabled");
    submitBtn.removeAttribute("disabled");
    submitBtn.classList.remove("disabled");
  });
}